import { render, staticRenderFns } from "./SplashDinein.vue?vue&type=template&id=6d88bbd8&lang=html"
import script from "./SplashDinein.vue?vue&type=script&lang=js"
export * from "./SplashDinein.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports